import React from 'react';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';

const ProgressBar = ({ count, total, sentiment, reverse }) => {
  const percentage = total > 0 ? Math.round((count / total) * 100) : 0;

  return (
    <div
      style={{
        width: '100%',
        height: '12px',
        borderRadius: '2px',
        boxShadow: '0px 4px 4.300000190734863px 0px #0000001A inset',
        overflow: 'hidden',
      }}
    >
      <div
        className={classNames('progress-bar', {
          [`progress-bar-${kebabCase(reverse ? `-${sentiment}-reverse` : sentiment)}`]:
            sentiment,
        })}
        style={{
          width: `${percentage}%`,
          height: '12px',
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
